import { render, staticRenderFns } from "./LayoutBasic2.vue?vue&type=template&id=691a9942&scoped=true"
import script from "./LayoutBasic2.vue?vue&type=script&lang=js"
export * from "./LayoutBasic2.vue?vue&type=script&lang=js"
import style0 from "./LayoutBasic2.vue?vue&type=style&index=0&id=691a9942&prod&lang=less&scoped=true"
import style1 from "./LayoutBasic2.vue?vue&type=style&index=1&id=691a9942&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691a9942",
  null
  
)

export default component.exports